module.exports = __webpack_public_path__ + "static/adoucisseur2-ff15d0cde06bc07ce8e9c5f95cf039ae.jpg";